import Button from "common/components/Button/Button"
import { useTranslation } from "react-i18next"

import "./styles.scss"

const PanelsHeader = ({ title, handleSubmit, disabled }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const showSaveButton = title !== "Validaciones"
  return (
    <div className='flex-row mt-2 contactos-panels-header d-flex justify-content-between align-items-center'>
      <div className='tw-mt-8'>{title}</div>
      {showSaveButton && (
        <Button
          className='!tw-bg-primary tw-cursor-pointer'
          onClick={handleSubmit}
          disabled={disabled}
        >
          {t("contactos.editar.dataAdvance.saveButton")}
        </Button>
      )}
    </div>
  )
}

export default PanelsHeader
